import { FC } from 'react';
import { Checkbox } from '@mui/material';
import { useSnapshot } from 'valtio';
import ApplicationsStore from '../stores/applications-store';
import { toggleAllSelected } from '../stores/applications-store-actions';
import { stopPropagation } from '../../common/common-utils';
import { important } from 'common-types';

const AllCheckboxContainer: FC<
  React.PropsWithChildren<AllCheckboxContainerProps>
> = props => {
  const { allSelected } = useSnapshot(ApplicationsStore);

  return (
    <Checkbox
      disableRipple
      size='small'
      checked={allSelected}
      onChange={toggleAllSelected}
      onClick={stopPropagation}
      sx={{ padding: important('1px') }}
    />
  );
};

export interface AllCheckboxContainerProps {}

export default AllCheckboxContainer;
